import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Col, Form as FormAntd, message, Row, Space, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, Form, FormItem, InputItem, InputNumberItem, ModalItem, SelectItem, SwitchItem, TabbedDynamicTable, TableItem, TagItem } from "../../../../Components/Items";
import { colorPaleta } from "../../../../Components/TagItem";
import SelectInsumosServicioBiwoItem from "../../../../Components/SelectInsumosServicioBiwoItem";
import { formatoDinero, postCobro, textoPrecioConcepto, TIPOS_PRECIO } from "./cobroBiwoTextos";

const Celda = ({ children }) => <td className="td-border">{children}</td>;
const Campo = (props) => <FormItem noStyle {...props} />;

const BotonAgregar = ({ texto, onClick }) => (
    <ButtonItem cyan block icon={<PlusOutlined />} style={{ marginTop: 10 }} onClick={onClick}>
        {texto}
    </ButtonItem>
);

const Estado = ({ activo }) => (activo ? <TagItem verdeNatural>Activo</TagItem> : <TagItem naranja>Inactivo</TagItem>);

const columnaFactura = {
    key: "agruparFactura",
    title: "En factura",
    width: "11%",
    filters: [{ text: "Mensualidad BIWO", value: "agrupa" }, { text: "Aparte", value: "aparte" }],
    onFilter: (valor, r) => (r.agruparFactura !== false ? "agrupa" : "aparte") === valor,
    render: (r) => (r.agruparFactura !== false ? <TagItem cyan>Mensualidad BIWO</TagItem> : <TagItem gris>Aparte</TagItem>),
};

const filtroEstado = { filters: [{ text: "Activo", value: "activo" }, { text: "Inactivo", value: "inactivo" }], onFilter: (valor, r) => (r.activo ? "activo" : "inactivo") === valor };

const estiloBarra = {
    backgroundColor: "white",
    padding: "12px 20px",
    border: "1px solid rgb(235, 237, 240)",
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
};

const estiloTarjeta = { backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" };

const Barra = ({ titulo, cantidad, children }) => (
    <div style={estiloBarra}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 15, fontWeight: 600, color: "#1a3a4a" }}>{titulo}</span>
            <TagItem cyan style={{ marginRight: 0 }}>{cantidad}</TagItem>
        </div>
        {children}
    </div>
);

const aDos = (valor) => Math.round(valor * 100) / 100;

const matrizInicial = (concepto) => {
    const fuentes = !concepto ? [] : concepto.tipoPrecio === "niveles" ? concepto.niveles || [] : [concepto];
    const cantidades = [...new Set(fuentes.flatMap((f) => (f.escalaEmpresas || []).map((e) => e.empresas)))].sort((a, b) => a - b);
    return {
        escalaFilas: cantidades.map((n) => ({
            empresas: n,
            precios: Object.fromEntries(fuentes.map((f, i) => [`c${i}`, f.escalaEmpresas?.find((e) => e.empresas === n)?.precio])),
        })),
        escalaAdicional: Object.fromEntries(fuentes.map((f, i) => [`c${i}`, f.precioEmpresaAdicional ?? undefined])),
    };
};

class CatalogoCobro extends Component {
    formConcepto = React.createRef();
    formCombo = React.createRef();
    state = {
        loading: false,
        conceptos: [],
        combos: [],
        medidores: { master: [], modulos: [] },
        unidades: {},
        conceptoEditado: undefined,
        comboEditado: undefined,
        claveConcepto: null,
        tipoPrecio: "fijo",
    };

    componentDidMount() {
        this.consultar();
        postCobro(axios, "selectModulosCobro", {}, this.props.headersToken).then((data) => {
            if (data.success === 2) this.setState({ medidores: { master: data.master, modulos: data.modulos }, unidades: data.unidades || {} });
        });
    }

    consultar = () => {
        this.setState({ loading: true });
        Promise.all([
            postCobro(axios, "selectConceptosCobro", {}, this.props.headersToken),
            postCobro(axios, "selectCombosCobro", {}, this.props.headersToken),
        ])
            .then(([conceptos, combos]) => {
                this.setState({
                    loading: false,
                    conceptos: conceptos.success === 2 ? conceptos.data : [],
                    combos: combos.success === 2 ? combos.data : [],
                });
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error de red al consultar el catálogo");
            });
    };

    guardar = (ruta, form, extra, cerrar) => {
        form.current.validateFields().then((values) => {
            this.setState({ loading: true });
            postCobro(axios, ruta, { ...values, ...extra }, this.props.headersToken)
                .then((data) => {
                    this.setState({ loading: false });
                    if (data.success === 2) {
                        message.success(data.message);
                        cerrar();
                        this.consultar();
                    } else {
                        message.error(data.message || "No se pudo guardar");
                    }
                })
                .catch(() => {
                    this.setState({ loading: false });
                    message.error("Error de red al guardar");
                });
        });
    };

    abrirCombo = (combo) => {
        this.consultar();
        this.setState({ comboEditado: combo });
    };

    abrirConcepto = (concepto) => {
        this.setState({ conceptoEditado: concepto, claveConcepto: concepto?.clave || null, tipoPrecio: concepto?.tipoPrecio || "fijo" });
    };

    nombreMedidor = (clave) => [...this.state.medidores.master, ...this.state.medidores.modulos].find((m) => m.clave === clave)?.nombre || clave;

    pie = (concepto, form, ruta, extra, cerrar) => (
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16, paddingTop: 12, borderTop: "1px solid #f0f0f0" }}>
            <Space size={8}>
                <ButtonItem danger onClick={cerrar}>Cancelar</ButtonItem>
                <ButtonItem onClick={() => this.guardar(ruta, form, extra, cerrar)}>Guardar</ButtonItem>
            </Space>
        </div>
    );

    nivelesActuales = () => this.formConcepto.current?.getFieldValue("niveles") || this.state.conceptoEditado?.niveles || [];

    siguienteCantidad = (usadas) => {
        let cantidad = 2;
        while (usadas.includes(cantidad)) cantidad += 1;
        return cantidad;
    };

    renderCeldasEscala(name, i, conPaquetes) {
        const datos = (getFieldValue) => {
            const empresas = Number(getFieldValue(["escalaFilas", name, "empresas"])) || 0;
            const total = getFieldValue(["escalaFilas", name, "precios", `c${i}`]);
            return { empresas, total, hay: total !== undefined && total !== null && empresas > 0 };
        };
        const fijarTotal = (valor) => this.formConcepto.current.setFields([{ name: ["escalaFilas", name, "precios", `c${i}`], value: valor === null || valor === undefined ? undefined : aDos(valor) }]);
        return (
            <>
                <Celda>
                    <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            const { empresas, total, hay } = datos(getFieldValue);
                            return (
                                <InputNumberItem
                                    dinero
                                    min={0}
                                    placeholder="c/u"
                                    value={hay ? aDos(total / empresas) : null}
                                    onChange={(valor) => (empresas ? fijarTotal(valor === null || valor === undefined ? valor : valor * empresas) : null)}
                                />
                            );
                        }}
                    </FormItem>
                </Celda>
                <Celda>
                    <Campo name={[name, "precios", `c${i}`]}>
                        <InputNumberItem dinero min={0} placeholder="Total" />
                    </Campo>
                </Celda>
                <Celda>
                    <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            const { empresas, total, hay } = datos(getFieldValue);
                            const sinDescuento = (Number(conPaquetes ? getFieldValue(["niveles", i, "precio"]) : getFieldValue("precio")) || 0) * empresas;
                            return (
                                <InputNumberItem
                                    porcentaje
                                    min={0}
                                    max={100}
                                    placeholder="%"
                                    precision={1}
                                    value={hay && sinDescuento ? aDos((1 - total / sinDescuento) * 100) : null}
                                    onChange={(valor) => (sinDescuento ? fijarTotal(valor === null || valor === undefined ? valor : sinDescuento * (1 - valor / 100)) : null)}
                                />
                            );
                        }}
                    </FormItem>
                </Celda>
            </>
        );
    }

    renderMatrizEscala() {
        const conPaquetes = this.state.tipoPrecio === "niveles";
        const columnas = conPaquetes ? this.nivelesActuales().map((n, i) => n?.nombre || `Paquete ${i + 1}`) : ["Precio"];
        const form = () => this.formConcepto.current;
        return (
            <div style={{ overflowX: "auto" }}>
            <table className="table table-12px" style={{ width: "100%", minWidth: 160 + columnas.length * 300, backgroundColor: "white", tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th className="th-border" rowSpan={2} style={{ width: "11%", textAlign: "center" }}>Empresas</th>
                        {columnas.map((titulo, i) => (
                            <th key={i} className="th-border" colSpan={3} style={{ textAlign: "center" }}>{titulo}</th>
                        ))}
                        <th className="th-border" rowSpan={2} style={{ width: 48 }} />
                    </tr>
                    <tr>
                        {columnas.map((_, i) => (
                            <React.Fragment key={i}>
                                <th className="th-border" title="Precio por empresa" style={{ textAlign: "center" }}>c/u</th>
                                <th className="th-border" title="Total que paga el corporativo" style={{ textAlign: "center" }}>Total</th>
                                <th className="th-border" title="Descuento contra el precio normal" style={{ width: "7%", textAlign: "center" }}>%</th>
                            </React.Fragment>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ background: "#f7f7fa" }}>
                        <td className="td-border" style={{ textAlign: "center", fontWeight: 600 }}>1</td>
                        {columnas.map((_, i) => (
                            <FormItem key={i} noStyle shouldUpdate>
                                {({ getFieldValue }) => {
                                    const base = Number(conPaquetes ? getFieldValue(["niveles", i, "precio"]) : getFieldValue("precio")) || 0;
                                    return (
                                        <>
                                            <td className="td-border" style={{ textAlign: "right", fontWeight: 600 }}>{formatoDinero(base)}</td>
                                            <td className="td-border" style={{ textAlign: "right", fontWeight: 600 }}>{formatoDinero(base)}</td>
                                            <td className="td-border" style={{ textAlign: "right", color: "#8c8c8c" }}>—</td>
                                        </>
                                    );
                                }}
                            </FormItem>
                        ))}
                        <td className="td-border" />
                    </tr>
                    <FormAntd.List name="escalaFilas">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name }) => (
                                    <tr key={key}>
                                        <Celda>
                                            <Campo name={[name, "empresas"]}>
                                                <InputNumberItem min={2} precision={0} placeholder="2" />
                                            </Campo>
                                        </Celda>
                                        {columnas.map((_, i) => (
                                            <React.Fragment key={i}>{this.renderCeldasEscala(name, i, conPaquetes)}</React.Fragment>
                                        ))}
                                        <Celda>
                                            <TablaQuitar onClick={() => remove(name)} />
                                        </Celda>
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan={columnas.length * 3 + 2}>
                                        <BotonAgregar
                                            texto="Agregar cantidad de empresas"
                                            onClick={() => add({ empresas: this.siguienteCantidad((form().getFieldValue("escalaFilas") || []).map((f) => Number(f?.empresas))) })}
                                        />
                                    </td>
                                </tr>
                            </>
                        )}
                    </FormAntd.List>
                    <tr>
                        <Celda>
                            <b title="Precio por empresa para las que pasen de la última fila" style={{ display: "block", textAlign: "center" }}>Extra</b>
                        </Celda>
                        {columnas.map((_, i) => (
                            <React.Fragment key={i}>
                                <Celda>
                                    <Campo name={["escalaAdicional", `c${i}`]}>
                                        <InputNumberItem dinero min={0} placeholder="Auto" />
                                    </Campo>
                                </Celda>
                                <td colSpan={2} />
                            </React.Fragment>
                        ))}
                        <td />
                    </tr>
                </tbody>
            </table>
            </div>
        );
    }

    tabEscala() {
        return { key: "escala", label: "Descuento por varias empresas", customContent: this.renderMatrizEscala() };
    }

    tabNiveles() {
        const unidad = this.state.medidores.modulos.find((m) => m.clave === this.state.claveConcepto)?.unidadLimite;
        const esIa = this.state.claveConcepto === "claude";
        const conLimite = unidad && !esIa;
        const columnas = [
            { title: "Paquete" },
            conLimite && { title: `Límite de ${this.state.unidades[unidad]?.[1] || unidad}`, width: "18%" },
            esIa && { title: "Consultas al día", width: "14%" },
            esIa && { title: "Consultas al mes", width: "14%" },
            { title: "Precio mensual (sin IVA)", width: "18%" },
            { title: "Activo", width: "8%" },
            { title: "", width: "6%" },
        ].filter(Boolean);

        return {
                        key: "niveles",
                        label: "Paquetes",
                        listName: "niveles",
                        minWidth: "100%",
                        columns: columnas,
                        renderRow: ({ key, name, remove }) => (
                            <tr key={key}>
                                <Celda>
                                    <Campo name={[name, "nombre"]} required>
                                        <InputItem placeholder="Ej. 500 empleados" />
                                    </Campo>
                                    <Campo name={[name, "_id"]} hidden>
                                        <InputItem />
                                    </Campo>
                                    <Campo name={[name, "paqueteIaId"]} hidden>
                                        <InputItem />
                                    </Campo>
                                </Celda>
                                {conLimite && (
                                    <Celda>
                                        <Campo name={[name, "limite"]}>
                                            <InputNumberItem min={1} precision={0} placeholder="Sin límite" />
                                        </Campo>
                                    </Celda>
                                )}
                                {esIa && (
                                    <Celda>
                                        <Campo name={[name, "consultasDiarias"]}>
                                            <InputNumberItem min={1} precision={0} placeholder="Sin límite" />
                                        </Campo>
                                    </Celda>
                                )}
                                {esIa && (
                                    <Celda>
                                        <Campo name={[name, "consultasMensuales"]}>
                                            <InputNumberItem min={1} precision={0} placeholder="Sin límite" />
                                        </Campo>
                                    </Celda>
                                )}
                                <Celda>
                                    <Campo name={[name, "precio"]} required>
                                        <InputNumberItem dinero min={0} />
                                    </Campo>
                                </Celda>
                                <Celda>
                                    <Campo name={[name, "activo"]} valuePropName="checked" initialValue={true}>
                                        <SwitchItem size="small" />
                                    </Campo>
                                </Celda>
                                <Celda>
                                    <TablaQuitar onClick={() => remove(name)} />
                                </Celda>
                            </tr>
                        ),
                        renderFooter: ({ add }) => <BotonAgregar texto="Agregar paquete" onClick={() => add({ activo: true })} />,
        };
    }

    tablasConcepto(esMaster) {
        const tabs = [];
        if (this.state.tipoPrecio === "niveles") tabs.push(this.tabNiveles());
        if (!esMaster && this.state.claveConcepto) tabs.push(this.tabEscala());
        return tabs.length ? <TabbedDynamicTable formInstance={this.formConcepto} tabs={tabs} /> : null;
    }

    renderModalConcepto() {
        const concepto = this.state.conceptoEditado;
        const { master, modulos } = this.state.medidores;
        const usadas = new Set(this.state.conceptos.filter((c) => c._id !== concepto?._id).map((c) => c.clave));
        const esMaster = master.some((m) => m.clave === this.state.claveConcepto);
        const unidadConcepto = modulos.find((m) => m.clave === this.state.claveConcepto)?.unidadLimite;
        const conLimite = !!unidadConcepto && unidadConcepto !== "consultas";
        const cerrar = () => this.setState({ conceptoEditado: undefined });

        return (
            <ModalItem
                visible={concepto !== undefined}
                title={concepto ? "Editar concepto" : "Nuevo concepto"}
                onCancel={cerrar}
                footer={null}
                destroyOnClose
                spinning={false}
                width={1100}
            >
                <Form
                    ref={this.formConcepto}
                    layout
                    initialValues={{
                        clave: concepto?.clave,
                        nombre: concepto?.nombre,
                        tipoPrecio: concepto?.tipoPrecio || "fijo",
                        precio: concepto?.precio ?? 0,
                        niveles: concepto?.niveles?.length ? concepto.niveles : [{ activo: true }],
                        bloquearAlExceder: concepto ? concepto.bloquearAlExceder !== false : true,
                        insumoId: concepto?.insumoId || undefined,
                        agruparFactura: concepto ? concepto.agruparFactura !== false : true,
                        precioUnidadExtra: concepto?.precioUnidadExtra ?? undefined,
                        ...matrizInicial(concepto),
                        activo: concepto ? concepto.activo !== false : true,
                    }}
                    onValuesChange={(cambios) => {
                        const form = this.formConcepto.current;
                        if ("niveles" in cambios) this.forceUpdate();
                        if (Array.isArray(cambios.escalaFilas)) {
                            cambios.escalaFilas.forEach((cambio, indice) => {
                                if (!cambio || !("empresas" in cambio) || cambio.empresas === null || cambio.empresas === undefined) return;
                                const otras = (form.getFieldValue("escalaFilas") || []).filter((_, i) => i !== indice).map((f) => Number(f?.empresas));
                                if (cambio.empresas >= 2 && !otras.includes(Number(cambio.empresas))) return;
                                message.warning(cambio.empresas < 2 ? "Con 1 empresa se cobra el precio normal; el descuento empieza en 2 empresas" : `Ya hay una fila para ${cambio.empresas} empresas`);
                                form.setFields([{ name: ["escalaFilas", indice, "empresas"], value: this.siguienteCantidad(otras) }]);
                            });
                        }
                        if ("clave" in cambios) {
                            const deMaster = master.some((m) => m.clave === cambios.clave);
                            form.setFieldsValue({
                                nombre: this.nombreMedidor(cambios.clave),
                                tipoPrecio: deMaster ? "unitario" : cambios.clave === "claude" ? "niveles" : form.getFieldValue("tipoPrecio") === "unitario" ? "fijo" : form.getFieldValue("tipoPrecio"),
                            });
                            this.setState({ claveConcepto: cambios.clave, tipoPrecio: form.getFieldValue("tipoPrecio") });
                        }
                        if ("tipoPrecio" in cambios) this.setState({ tipoPrecio: cambios.tipoPrecio });
                    }}
                >
                    <Row gutter={12}>
                        <Col xs={24} md={12}>
                            <FormItem margin label="¿Qué se cobra?" name="clave" required>
                                <SelectItem width="100%"
                                    disabled={!!concepto}
                                    showSearch
                                    optionFilterProp="label"
                                    options={[
                                        { label: "Por master", options: master.map((m) => ({ value: m.clave, label: m.nombre, disabled: usadas.has(m.clave) })) },
                                        { label: "Complementos por empresa", options: modulos.map((m) => ({ value: m.clave, label: m.nombre, disabled: usadas.has(m.clave) })) },
                                    ]}
                                />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={12}>
                            <FormItem margin label="Nombre" name="nombre" required>
                                <InputItem maxLength={80} />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={12}>
                            <FormItem margin label="Tipo de precio" name="tipoPrecio" required>
                                <SelectItem width="100%" options={TIPOS_PRECIO.filter((t) => (esMaster ? t.value !== "niveles" : this.state.claveConcepto === "claude" ? t.value === "niveles" : t.value !== "unitario"))} />
                            </FormItem>
                        </Col>
                        {this.state.tipoPrecio !== "niveles" && (
                            <Col xs={24} md={12}>
                                <FormItem margin label="Precio mensual" tooltip="Sin IVA" name="precio" required>
                                    <InputNumberItem dinero min={0} />
                                </FormItem>
                            </Col>
                        )}
                        <Col xs={24} md={12}>
                            <FormItem margin label="Activo" name="activo" valuePropName="checked">
                                <SwitchItem />
                            </FormItem>
                        </Col>
                        {conLimite && this.state.tipoPrecio === "niveles" && (
                            <Col xs={24} md={12}>
                                <FormItem margin label="Bloquear exceso" name="bloquearAlExceder" valuePropName="checked" tooltip="Valor por defecto; se puede cambiar por empresa">
                                    <SwitchItem />
                                </FormItem>
                            </Col>
                        )}
                        {unidadConcepto === "empleados" && this.state.tipoPrecio === "niveles" && (
                            <Col xs={24} md={12}>
                                <FormItem margin label="Empleado adicional" name="precioUnidadExtra" tooltip="Precio sin IVA de cada empleado que pase el límite del paquete. Con precio ya no se bloquea el alta. Vacío = se bloquea o se deja pasar sin cobrar.">
                                    <InputNumberItem dinero min={0} placeholder="Sin cobro de excedente" />
                                </FormItem>
                            </Col>
                        )}
                        <Col xs={24} md={12}>
                            <FormItem margin label="Insumo remisión" name="insumoId">
                                <SelectInsumosServicioBiwoItem width="100%" />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={12}>
                            <FormItem margin label="Mensualidad BIWO" name="agruparFactura" valuePropName="checked" tooltip="Encendido: en la factura va dentro de la partida “Mensualidad BIWO”. Apagado: sale en un renglón aparte.">
                                <SwitchItem />
                            </FormItem>
                        </Col>
                    </Row>
                    {this.tablasConcepto(esMaster)}
                    {this.pie(concepto, this.formConcepto, "guardarConceptoCobro", { conceptoId: concepto?._id }, cerrar)}
                </Form>
            </ModalItem>
        );
    }

    renderModalCombo() {
        const combo = this.state.comboEditado;
        const complementos = this.state.conceptos.filter((c) => c.alcance === "empresa" && c.activo !== false);
        const opcionesComplemento = this.state.medidores.modulos.map((m) => {
            const concepto = complementos.find((c) => c.clave === m.clave);
            return concepto ? { value: concepto._id, label: concepto.nombre } : { value: `sin-${m.clave}`, label: `${m.nombre} (sin precio en catálogo)`, disabled: true };
        });
        const cerrar = () => this.setState({ comboEditado: undefined });

        return (
            <ModalItem
                visible={combo !== undefined}
                title={combo ? "Editar combo" : "Nuevo combo"}
                onCancel={cerrar}
                footer={null}
                destroyOnClose
                spinning={false}
                width={800}
            >
                <Form
                    ref={this.formCombo}
                    layout
                    initialValues={{
                        nombre: combo?.nombre,
                        precio: combo?.precio,
                        items: combo?.items?.length ? combo.items.map((i) => ({ conceptoId: i.conceptoId, nivelId: i.nivelId || undefined })) : [{}, {}],
                        insumoId: combo?.insumoId || undefined,
                        agruparFactura: combo ? combo.agruparFactura !== false : true,
                        activo: combo ? combo.activo !== false : true,
                    }}
                >
                    <Row gutter={12}>
                        <Col xs={24} md={12}>
                            <FormItem margin label="Nombre" name="nombre" required>
                                <InputItem maxLength={80} />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={12}>
                            <FormItem margin label="Precio mensual" tooltip="Sin IVA" name="precio" required>
                                <InputNumberItem dinero min={0} />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={12}>
                            <FormItem margin label="Activo" name="activo" valuePropName="checked">
                                <SwitchItem />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={12}>
                            <FormItem margin label="Insumo remisión" name="insumoId">
                                <SelectInsumosServicioBiwoItem width="100%" />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={12}>
                            <FormItem margin label="Mensualidad BIWO" name="agruparFactura" valuePropName="checked" tooltip="Encendido: en la factura va dentro de la partida “Mensualidad BIWO”. Apagado: sale en un renglón aparte.">
                                <SwitchItem />
                            </FormItem>
                        </Col>
                    </Row>
                    <TabbedDynamicTable
                        formInstance={this.formCombo}
                        tabs={[
                            {
                                key: "items",
                                label: "Complementos incluidos",
                                listName: "items",
                                minWidth: "100%",
                                columns: [{ title: "Complemento", width: "45%" }, { title: "Paquete", width: "35%" }, { title: "Precio suelto" }, { title: "", width: "6%" }],
                                renderRow: ({ key, name, remove }) => (
                                    <FormItem key={key} noStyle shouldUpdate>
                                        {({ getFieldValue }) => {
                                            const item = getFieldValue(["items", name]) || {};
                                            const concepto = complementos.find((c) => c._id === item.conceptoId);
                                            const nivel = concepto?.niveles?.find((n) => n._id === item.nivelId);
                                            const suelto = concepto ? (concepto.tipoPrecio === "niveles" ? nivel?.precio : concepto.precio) : null;
                                            return (
                                                <tr>
                                                    <Celda>
                                                        <Campo name={[name, "conceptoId"]} required>
                                                            <SelectItem width="100%" placeholder="Complemento" options={opcionesComplemento} />
                                                        </Campo>
                                                    </Celda>
                                                    <Celda>
                                                        {concepto?.tipoPrecio === "niveles" ? (
                                                            <Campo name={[name, "nivelId"]} required>
                                                                <SelectItem width="100%" placeholder="Paquete" options={concepto.niveles.map((n) => ({ value: n._id, label: n.nombre }))} />
                                                            </Campo>
                                                        ) : (
                                                            "—"
                                                        )}
                                                    </Celda>
                                                    <Celda>{suelto !== null && suelto !== undefined ? formatoDinero(suelto) : "—"}</Celda>
                                                    <Celda>
                                                        <TablaQuitar onClick={() => remove(name)} />
                                                    </Celda>
                                                </tr>
                                            );
                                        }}
                                    </FormItem>
                                ),
                                renderFooter: ({ add }) => (
                                    <>
                                        <BotonAgregar texto="Agregar complemento" onClick={() => add({})} />
                                        <FormItem noStyle shouldUpdate>
                                            {({ getFieldValue }) => {
                                                const suelto = (getFieldValue("items") || []).reduce((suma, item) => {
                                                    const concepto = complementos.find((c) => c._id === item?.conceptoId);
                                                    const precio = concepto ? (concepto.tipoPrecio === "niveles" ? concepto.niveles.find((n) => n._id === item.nivelId)?.precio : concepto.precio) : 0;
                                                    return suma + (precio || 0);
                                                }, 0);
                                                const precio = Number(getFieldValue("precio") || 0);
                                                return (
                                                    <div style={{ marginTop: 10, display: "flex", justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap", gap: 8, color: "#8c8c8c" }}>
                                                        {suelto > 0 ? (
                                                            <>
                                                                <TagItem gris style={{ marginRight: 0 }}>Suelto: <b>{formatoDinero(suelto)}</b></TagItem>
                                                                <TagItem cyan style={{ marginRight: 0 }}>Combo: <b>{formatoDinero(precio)}</b></TagItem>
                                                                {suelto > precio ? (
                                                                    <TagItem verdeNatural style={{ marginRight: 0 }}>Ahorro: <b>{formatoDinero(suelto - precio)}</b></TagItem>
                                                                ) : (
                                                                    <TagItem naranja style={{ marginRight: 0 }}>El combo sale más caro que suelto</TagItem>
                                                                )}
                                                            </>
                                                        ) : (
                                                            "Elige los complementos para ver el ahorro"
                                                        )}
                                                    </div>
                                                );
                                            }}
                                        </FormItem>
                                    </>
                                ),
                            },
                        ]}
                    />
                    {this.pie(combo, this.formCombo, "guardarComboCobro", { comboId: combo?._id }, cerrar)}
                </Form>
            </ModalItem>
        );
    }

    renderConceptos() {
        return (
            <>
                <Barra titulo="Conceptos de cobro" cantidad={this.state.conceptos.length}>
                    <ButtonItem botonAncho icon={<PlusOutlined />} onClick={() => this.abrirConcepto(null)}>Nuevo concepto</ButtonItem>
                </Barra>
                <div style={estiloTarjeta}>
                    <TableItem
                        size="small"
                        loading={this.state.loading}
                        dataSource={this.state.conceptos.map((c) => ({ ...c, precioTexto: textoPrecioConcepto(c) }))}
                        columns={[
                            { key: "nombre", title: "Concepto", dataIndex: "nombre", width: "14%", buscar: "nombre" },
                            {
                                key: "alcance",
                                title: "Se cobra",
                                width: "10%",
                                filters: [{ text: "Por master", value: "master" }, { text: "Por empresa", value: "empresa" }],
                                onFilter: (valor, c) => (valor === "master" ? c.alcance === "master" : c.alcance !== "master"),
                                render: (c) => (c.alcance === "master" ? <TagItem azul>Por master</TagItem> : <TagItem morado>Por empresa</TagItem>),
                            },
                            {
                                key: "precio",
                                title: "Precio mensual (sin IVA)",
                                width: "14%",
                                buscar: "precioTexto",
                                filters: TIPOS_PRECIO.map((t) => ({ text: t.label, value: t.value })),
                                onFilter: (valor, c) => c.tipoPrecio === valor,
                                render: (c) => c.precioTexto,
                            },
                            {
                                key: "exceder",
                                title: "Al exceder",
                                width: "12%",
                                filters: [{ text: "Cobra excedente", value: "cobra" }, { text: "Bloquea", value: "bloquea" }, { text: "Deja pasar", value: "pasa" }, { text: "—", value: "nada" }],
                                onFilter: (valor, c) => (c.precioUnidadExtra > 0 ? "cobra" : c.niveles?.some((n) => n.limite) ? (c.bloquearAlExceder ? "bloquea" : "pasa") : "nada") === valor,
                                render: (c) =>
                                    c.precioUnidadExtra > 0
                                        ? `Cobra ${formatoDinero(c.precioUnidadExtra)} por empleado adicional`
                                        : c.niveles?.some((n) => n.limite) ? (c.bloquearAlExceder ? "Bloquea" : "Deja pasar") : "—",
                            },
                            {
                                key: "escala",
                                title: "Escala por empresas",
                                width: "10%",
                                filters: [{ text: "Con escala", value: "con" }, { text: "Sin escala", value: "sin" }],
                                onFilter: (valor, c) => (c.escalaEmpresas?.length || c.niveles?.some((n) => n.escalaEmpresas?.length) ? "con" : "sin") === valor,
                                render: (c) => (c.escalaEmpresas?.length || c.niveles?.some((n) => n.escalaEmpresas?.length) ? <TagItem cyan>Con escala</TagItem> : "—"),
                            },
                            { key: "insumoNombre", title: "Insumo", dataIndex: "insumoNombre", width: "15%", buscar: "insumoNombre", render: (v) => v || "Sin asignar" },
                            columnaFactura,
                            { key: "estado", title: "Estado", width: "8%", ...filtroEstado, render: (c) => <Estado activo={c.activo} /> },
                            {
                                key: "acciones",
                                title: "Acciones",
                                width: 80,
                                align: "center",
                                render: (c) => (
                                    <Tooltip title="Editar">
                                        <ButtonItem size="small" naranja icon={<EditOutlined />} onClick={() => this.abrirConcepto(c)} />
                                    </Tooltip>
                                ),
                            },
                        ]}
                    />
                </div>
            </>
        );
    }

    renderCombos() {
        return (
            <>
                <Barra titulo="Combos" cantidad={this.state.combos.length}>
                    <ButtonItem botonAncho icon={<PlusOutlined />} onClick={() => this.abrirCombo(null)}>Nuevo combo</ButtonItem>
                </Barra>
                <div style={estiloTarjeta}>
                    <TableItem
                        size="small"
                        loading={this.state.loading}
                        dataSource={this.state.combos.map((c) => ({ ...c, incluyeTexto: c.items.map((i) => `${i.conceptoNombre}${i.nivelNombre ? ` ${i.nivelNombre}` : ""}`).join(" + ") }))}
                        columns={[
                            { key: "nombre", title: "Combo", dataIndex: "nombre", width: "18%", buscar: "nombre" },
                            {
                                key: "incluye",
                                title: "Incluye",
                                buscar: "incluyeTexto",
                                render: (c) => c.incluyeTexto,
                            },
                            { key: "precioSuelto", title: "Suelto (sin IVA)", dataIndex: "precioSuelto", width: "12%", align: "right", sorter: (a, b) => (a.precioSuelto || 0) - (b.precioSuelto || 0), render: formatoDinero },
                            { key: "precio", title: "Combo (sin IVA)", dataIndex: "precio", width: "12%", align: "right", sorter: (a, b) => (a.precio || 0) - (b.precio || 0), render: formatoDinero },
                            { key: "ahorro", title: "Ahorro", dataIndex: "ahorro", width: "12%", align: "right", sorter: (a, b) => (a.ahorro || 0) - (b.ahorro || 0), render: (v) => (v > 0 ? <b style={{ color: colorPaleta("verdeNatural") }}>{formatoDinero(v)}</b> : <TagItem naranja style={{ marginRight: 0 }}>No conviene</TagItem>) },
                            columnaFactura,
                            { key: "estado", title: "Estado", width: "9%", ...filtroEstado, render: (c) => <Estado activo={c.activo} /> },
                            {
                                key: "acciones",
                                title: "Acciones",
                                width: 80,
                                align: "center",
                                render: (c) => (
                                    <Tooltip title="Editar">
                                        <ButtonItem size="small" naranja icon={<EditOutlined />} onClick={() => this.abrirCombo(c)} />
                                    </Tooltip>
                                ),
                            },
                        ]}
                    />
                </div>
            </>
        );
    }

    render() {
        return (
            <>
                {this.props.vista === "combos" ? this.renderCombos() : this.renderConceptos()}
                {this.renderModalConcepto()}
                {this.renderModalCombo()}
            </>
        );
    }
}

const TablaQuitar = ({ onClick }) => (
    <Tooltip title="Quitar">
        <ButtonItem size="small" danger icon={<DeleteOutlined />} onClick={onClick} />
    </Tooltip>
);

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken });

export default connect(mapStateToProps)(CatalogoCobro);
